import React, { PureComponent } from 'react';
import Intercom from './Intercom';
import Jivo from './Jivo';
import Live from './Live';
import Tawkto from './Tawkto';
import Zendesk from './Zendesk';
import Zopim from './Zopim';

interface IProps {
  chats: any;
}

export default class Chats extends PureComponent<IProps> {
  static defaultProps = {
    chats: {}
  };

  render() {
    const { chats } = this.props;

    return (
      <div>
        {chats.hasjivochat && <Jivo code={chats.jivochat} />}
        {chats.haslivechat && <Live license={chats.livechat} chatBetweenGroups={false} />}
        {chats.hastawktochat && <Tawkto code={chats.tawktochat} />}
        {chats.haszendeskchat && <Zendesk code={chats.zendeskchat} />}
        {chats.haszopimchat && <Zopim code={chats.zopimchat} />}
        {chats.hasintercom && <Intercom code={chats.intercom} />}
      </div>
    );
  }
}
